import { render, staticRenderFns } from "./DialogFiles.vue?vue&type=template&id=5cb92912"
import script from "./DialogFiles.vue?vue&type=script&lang=js"
export * from "./DialogFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports